enum AccessTypes {
  FULL_ACCESS = 'full_access',
  LIMITED_ACCESS = 'limited_access',
  GRANT_ACCESS = 'grant_access'
}

export default AccessTypes;
